<template>
    <SphIcon
        v-if="config !== null"
        :icon="config.icon"
        :size="config.size"
        :title="config.title"
        :class="config.class"
        style="font-weight: bold"
    />
</template>

<script>
import { CircleCheck, Hourglass,OctagonX, SquareMinus, SquarePlus, TriangleAlert} from 'lucide';
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubTransactionInvoice from '@legacy/js/dto/ClubTransactionInvoice.js';
import Helper from '../../../js/accounting/Helper.js';
import { SphIcon } from '@/components/base/icon/index.ts';

export default {
    components: {
        'SphIcon': SphIcon,
    },
    props: {
        invoice: {
            type: [ClubInvoice, ClubTransactionInvoice],
            required: true,
        },
    },
    data() {
        return {
            helper: new Helper(),
            Hourglass,
            CircleCheck,
            TriangleAlert,
            OctagonX,
        }
    },
    computed: {
        color() {
            return 'black';
        },
        config() {
            let titleSuffix = ' (' + this.$t('am {date}', {date: this.localizedDate(this.invoice.status.appliedAt)}) + ')';
            if (this.invoice.status.status === ClubInvoice.STATUS_OPEN) {
                return {
                    icon: Hourglass,
                    size: 'sm',
                    title: this.$t('Zahlung offen') + titleSuffix,
                    class: 'text-gray-600',
                }
            } else if (this.invoice.status.status === ClubInvoice.STATUS_PAID) {
                const title = this.invoice.reverseInvoice ?
                    this.$t('Rechnung storniert') :
                    this.$t('Rechnung bezahlt');
                return {
                    size: 'md',
                    icon: this.invoice.reverseInvoice ? this.OctagonX : this.CircleCheck,
                    title: title + titleSuffix,
                    class: this.invoice.reverseInvoice ? 'text-error' : 'text-success',
                }
            } else if (this.invoice.status.status === ClubInvoice.STATUS_CHARGEBACK) {
                let title = this.$t('Rücklastschrift');
                if (null !== this.invoice.chargeback?.reason) {
                    title += ' "' + this.helper.translateChargebackReason(this.invoice.chargeback?.reason) + '"';
                }
                title += titleSuffix;
                if (this.invoice.isPayoffRequired()) {
                    return {
                        size: 'md',
                        icon: SquarePlus,
                        title: title + ' · ' + this.$t('Überzahlung'),
                        class: 'text-success',
                    }
                }
                return {
                    size: 'md',
                    icon: TriangleAlert,
                    title: title,
                    class: 'text-error',
                }
            } else if (this.invoice.status.status === ClubInvoice.STATUS_UNEQUAL) {
                const title = this.invoice.isPaymentRequired() ? this.$t('Unterzahlung') : this.$t('Überzahlung');
                return {
                    size: 'md',
                    icon: this.invoice.isPaymentRequired() ?  SquareMinus : SquarePlus,
                    title: title + titleSuffix,
                    class: this.invoice.isPaymentRequired() ? 'text-error' : 'text-success',
                }
            }
            return null;
        },
    },
    methods: {
        localizedDate(Ymd) {
            return this.helper.formatDate(Ymd)
        }
    },
}
</script>
